"use client";
import Minus from "@/public/icon/minusB.svg";
import Plus from "@/public/icon/plusB.svg";
import { useState, useEffect } from "react";

export default function QuantitySelector({ count = 1, onChange }) {
  const [quantity, setQuantity] = useState(count);

  useEffect(() => {
    setQuantity(count);
  }, [count]);

  const increase = () => {
    const newQty = quantity + 1;
    setQuantity(newQty);
    onChange?.(newQty);
  };

  const decrease = () => {
    const newQty = quantity > 1 ? quantity - 1 : 1;
    setQuantity(newQty);
    onChange?.(newQty);
  };

  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value > 0) {
      setQuantity(value);
      onChange?.(value);
    }
  };

  return (
    <div className="quantity-selector">
      <button onClick={decrease}>
        <Minus />
      </button>
      <input type="number" value={quantity} onChange={handleChange} min="1" />
      <button onClick={increase}>
        <Plus />
      </button>
    </div>
  );
}
